
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage";
import "firebase/storage";
// import firebase from 'firebase/app'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDOi460Z8ihXP5Le87v0NcQCBjP0Y5jaXA",
  authDomain: "fashionmonster-b8b0c.firebaseapp.com",
  databaseURL: "https://fashionmonster-b8b0c-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "fashionmonster-b8b0c",
  storageBucket: "fashionmonster-b8b0c.appspot.com",
  messagingSenderId: "350468218667",
  appId: "1:350468218667:web:2485573d3550ca77d52f6e",
  measurementId: "G-RFVSERTXFY"
};

// Initialize Firebase


export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);

export const analytics = getAnalytics(app);